import React, { Component } from 'react';
import {
  Grid,
  MenuItem,
  Paper,
  Select,
  TextField,
  IconButton,
  CircularProgress,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { send_request } from '../../utils/Request';
import { withStyles } from '@mui/styles';

const styles = theme => ({
  credential: {
    backgroundColor: theme.palette.action.hover,
    borderRadius: '4px',
    color: theme.palette.text.secondary,
    visibility: '',
    padding: '4px 8px',
  },
});
class SelectCredential extends Component {
  constructor(props) {
    super(props);
    this.state = {
      credentialData: [],
      isRefreshing: false,
    };
  }

  componentDidMount() {
    this.refreshData();
  }
  refreshData = () => {
    this.setState({ isRefreshing: true });
    let credentialData = [];
    send_request('ai-service/credential/user/type/SMTP', '', '', 'GET')
      .then(res => {
        if (res.data) {
          credentialData = credentialData.concat(res.data);
          this.setState({
            credentialData: credentialData,
            isRefreshing: false,
          });
        }
      })
      .catch(e => {
        console.log(e);
        this.setState({ isRefreshing: false });
      });
  };

  render() {
    return (
      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <Select
            fullWidth={true}
            className={this.props.classes.credential}
            disableUnderline
            variant="standard"
            displayEmpty
            defaultValue={null}
            value={this.props.value}
            onChange={value => {
              this.props.onChange(value.target.value);
            }}
          >
            <MenuItem value={null}>noreply@workflow86mail.com</MenuItem>
            {this.state.credentialData &&
              this.state.credentialData.map(credential => (
                <MenuItem value={credential.credentialId}>{credential.name}</MenuItem>
              ))}
            <MenuItem
              onClick={() => {
                window.open('/credential_store', '_blank');
              }}
            >
              + add credential
            </MenuItem>
          </Select>
        </Grid>
        <Grid item>
          <IconButton
            size="small"
            onClick={this.refreshData}
            sx={{ color: 'text.secondary' }}
            disabled={this.state.isRefreshing}
          >
            {this.state.isRefreshing ? (
              <CircularProgress size={20} sx={{ color: 'text.secondary' }} />
            ) : (
              <RefreshIcon fontSize="small" />
            )}
          </IconButton>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(SelectCredential);
